import type { Address } from '@personly/libs-types';

export const toAddressLine = (address: Address) =>
  [
    `${address.street} ${address.number}`,
    address.extra,
    `${address.postalCode} ${address.city.name}`,
    address.city.provinceName,
    address.city.countryName,
  ]
    .filter(Boolean)
    .join(', ');
